import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "417",
  "slug": "spot-uae-from-satellite-imagery",
  "title": "How to Recognise the UAE in Satellite Images",
  "excerpt": "The United Arab Emirates sits along the southern side of the Persian Gulf, with the Hajar Mountains toward the east and desert extending inland.",
  "date": "2026-06-12",
  "category": "Geography",
  "image": "/blog-images/uae.jpg",
  "readTime": "1 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "The United Arab Emirates sits along the southern side of the Persian Gulf, with the Hajar Mountains toward the east and desert extending inland. Dubai and Abu Dhabi provide recognisable coastal layouts when the image is detailed enough."
    },
    {
      "type": "heading",
      "text": "Checking the location"
    },
    {
      "type": "paragraph",
      "text": "Use the relationship between coast, urban development, and mountains. Sand dunes and irrigated landscaping are shared with neighbouring countries. Reclaimed islands can be helpful anchors, but a 2004 regional composite predates much subsequent construction. Check acquisition dates before comparing it with a current map, and do not infer borders from the edge of a built-up area."
    }
  ],
  "imageAlt": "the United Arab Emirates regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
